import { Button, Checkbox, FormControlLabel, FormGroup, FormLabel } from '@mui/material';
import type { AsyncZippable } from 'fflate';
import { strToU8, zip } from 'fflate';

import { useRoutes } from '@/hooks/useRoutes';
import { useRoutesStore } from '@/stores/useRoutesStore';
import { useUserStore } from '@/stores/useUserStore';
import { RouteLocationType } from '@/types/RouteLocationType';

export function AdminModeControl() {
  const origin = useRoutesStore((state) => state.routeLocations[RouteLocationType.ORIGIN]);
  const destination = useRoutesStore((state) => state.routeLocations[RouteLocationType.DESTINATION]);
  const time = useRoutesStore((state) => state.time);

  const { setAdminMode } = useUserStore((state) => state.actions);
  const route = useRoutes();

  return (
    <FormGroup sx={{ marginTop: 2 }}>
      <FormLabel sx={{ color: 'common.white', marginBottom: 1, fontWeight: 'bold' }}>Adminmodus</FormLabel>

      <FormControlLabel
        control={<Checkbox checked onChange={() => setAdminMode(false)} size="small" />}
        label="Aktiv"
        sx={{ marginBottom: 1 }}
      />

      <Button
        disabled={!route.data}
        sx={{ ':disabled': { color: 'common.white', opacity: 0.5 } }}
        onClick={async () => {
          try {
            if (!route.data) {
              return;
            }

            const { triasRequest: request, ...response } = route.data;
            const files: AsyncZippable = {
              'request.json': strToU8(JSON.stringify(request, undefined, 2)),
              'response.json': strToU8(JSON.stringify(response, undefined, 2)),
            };

            const zipFile = await new Promise<Uint8Array>((resolve, reject) => {
              zip(files, {}, (error, data) => {
                if (error) reject(error);
                resolve(data);
              });
            });

            const ab = new ArrayBuffer(zipFile.byteLength);
            new Uint8Array(ab).set(zipFile);

            const a = document.createElement('a');
            const file = new Blob([ab], { type: 'application/zip' });
            a.href = URL.createObjectURL(file);
            a.download = `${window.location.hostname} - ${origin?.properties.name.full} - ${
              destination?.properties.name.full
            } - ${time.date.format('YYYY-MM-DD HHmm')}.zip`;
            a.click();
          } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Something went wrong during routes response download');
            // eslint-disable-next-line no-console
            console.error(error);
          }
        }}
      >
        Download Routing
        <br />
        Requests & Responses
      </Button>
    </FormGroup>
  );
}
